var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import allMealsProductCardSrc from '@images/marketing/product_cards/recipes.jpg';
import { MealName, recipeInfo } from '@marketing/content';
export var headline = 'Delicious Meals';
var mealsPDPHeadline = 'Our Exciting Variety of Recipes';
export var tumblerText = ['Do-That-Dance', 'Floor-Licking', 'Irresistably', 'Dazzlingly'];
export var tumblerOptions = {
    period: 0.36,
    spinForce: 0.3,
    mask: 0.75,
    radius: 0.35,
    steepness: 0.5,
};
var products = (_a = {},
    _a[MealName.Turkey] = {
        name: recipeInfo[MealName.Turkey].tileDisplayName,
        image: recipeInfo[MealName.Turkey].image,
        productId: recipeInfo[MealName.Turkey].productId,
        url: recipeInfo[MealName.Turkey].url,
    },
    _a[MealName.Beef] = {
        name: recipeInfo[MealName.Beef].tileDisplayName,
        image: recipeInfo[MealName.Beef].image,
        productId: recipeInfo[MealName.Beef].productId,
        url: recipeInfo[MealName.Beef].url,
    },
    _a[MealName.Pork] = {
        name: recipeInfo[MealName.Pork].tileDisplayName,
        image: recipeInfo[MealName.Pork].image,
        productId: recipeInfo[MealName.Pork].productId,
        url: recipeInfo[MealName.Pork].url,
    },
    _a[MealName.Chicken] = {
        name: recipeInfo[MealName.Chicken].tileDisplayName,
        image: recipeInfo[MealName.Chicken].image,
        productId: recipeInfo[MealName.Chicken].productId,
        url: recipeInfo[MealName.Chicken].url,
    },
    _a[MealName.TurkeyChicken] = {
        name: recipeInfo[MealName.TurkeyChicken].tileDisplayName,
        image: recipeInfo[MealName.TurkeyChicken].image,
        productId: recipeInfo[MealName.TurkeyChicken].productId,
        url: recipeInfo[MealName.TurkeyChicken].url,
    },
    _a[MealName.Lamb] = {
        name: recipeInfo[MealName.Lamb].tileDisplayName,
        image: recipeInfo[MealName.Lamb].image,
        productId: recipeInfo[MealName.Lamb].productId,
        url: recipeInfo[MealName.Lamb].url,
    },
    _a[MealName.SamplerPack] = {
        name: recipeInfo[MealName.SamplerPack].tileDisplayName,
        image: recipeInfo[MealName.SamplerPack].image,
        tileImage: recipeInfo[MealName.SamplerPack].tileImage,
        productId: recipeInfo[MealName.SamplerPack].productId,
        url: recipeInfo[MealName.SamplerPack].url,
        fullbleed: true,
        fontColor: 'text-white',
    },
    _a.all_meals = {
        name: 'All Meals',
        image: {
            src: allMealsProductCardSrc,
            alt: 'All Meals Product Card',
        },
        productId: 'all_meals',
        url: '/meals',
        fullbleed: true,
        fontColor: 'text-white',
    },
    _a);
export var mealPromoContent = {
    retailPage: {
        headline: headline,
        tumblerText: tumblerText,
        tumblerOptions: tumblerOptions,
        ctaUrl: '/meals',
        products: [
            products[MealName.Beef],
            products[MealName.Chicken],
            products[MealName.Turkey],
            products[MealName.Lamb],
            products[MealName.TurkeyChicken],
            products[MealName.SamplerPack],
        ],
    },
    stackedMealsOnly: {
        headline: headline,
        tumblerText: tumblerText,
        tumblerOptions: tumblerOptions,
        ctaUrl: '/meals',
        products: [
            products[MealName.Turkey],
            products[MealName.Beef],
            products[MealName.Pork],
            products[MealName.Chicken],
        ],
    },
    stackedWithFullBleed: {
        headline: headline,
        tumblerText: tumblerText,
        tumblerOptions: tumblerOptions,
        products: [
            products[MealName.Turkey],
            products[MealName.Beef],
            products[MealName.Pork],
            products.all_meals,
        ],
    },
    treatsPLP: {
        headline: 'Our Exciting Meals',
        subhead: 'Treat your pup to an enticing variety of vet-developed, do-that-dance delicious recipes.',
        products: [
            products[MealName.Beef],
            products[MealName.Chicken],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    get treatsPDP() {
        return __assign(__assign({}, this.treatsPLP), { headline: 'Treat Them to Exciting Meals', subhead: null });
    },
    get probioticsPLP() {
        return __assign(__assign({}, this.treatsPLP), { headline: 'The Way To Their Heart', subhead: 'An enticing variety of vet-developed, floor-licking delicious recipes.' });
    },
    get probioticsPDP() {
        return __assign(__assign({}, this.treatsPLP), { headline: 'For Dogs with Great Taste', subhead: null });
    },
    get allProductsPLP() {
        return __assign(__assign({}, this.treatsPLP), { headline: headline, tumblerText: tumblerText, tumblerOptions: tumblerOptions, subhead: 'A variety of vet-developed recipes bursting with tantalizing textures and tastes.' });
    },
};
export var mealsPDPMealPromoContent = (_b = {},
    _b[MealName.Chicken] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Pork],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    _b[MealName.Turkey] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Pork],
            products[MealName.Chicken],
            products.all_meals,
        ],
    },
    _b[MealName.Pork] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Chicken],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    _b[MealName.Beef] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Turkey],
            products[MealName.Pork],
            products[MealName.Chicken],
            products.all_meals,
        ],
    },
    _b[MealName.Lamb] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Turkey],
            products[MealName.Chicken],
            products.all_meals,
        ],
    },
    _b[MealName.TurkeyChicken] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Chicken],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    _b);
export var treatsPDPMealPromoContent = (_c = {},
    _c[MealName.Chicken] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Pork],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    _c[MealName.Turkey] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Pork],
            products[MealName.Chicken],
            products.all_meals,
        ],
    },
    _c[MealName.Pork] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Chicken],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    _c[MealName.Beef] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Turkey],
            products[MealName.Pork],
            products[MealName.Chicken],
            products.all_meals,
        ],
    },
    _c[MealName.Lamb] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Turkey],
            products[MealName.Chicken],
            products.all_meals,
        ],
    },
    _c[MealName.TurkeyChicken] = {
        headline: mealsPDPHeadline,
        products: [
            products[MealName.Beef],
            products[MealName.Chicken],
            products[MealName.Turkey],
            products.all_meals,
        ],
    },
    _c);
